const messages = {
  logout: 'Logout',
  administrator: 'Administrator',
  help: 'Help',
  'code-regist': 'Code Regist',
  'code-modify': 'Code Modify',
  Echart: 'Echart',
  // footer
  address: '1000, Bangeojinsunhwan-doro, Dong-gu, Ulsan, 44032',
  tel: 'Tel : +82 52-202-2114',
  legal: 'Legal',
  email: 'Reject email',
  'email-address': 'Email',
  'header-ci': 'ci_en',
  'footer-ci': 'footer_ci_en',
  'i18n-btn': 'mdi-alpha-a-box-outline',
  'etc': 'Etc',
  // 버튼
  'label.retrieve': 'retrieve', // 조회
  'label.save': 'save', // 저장
  'label.delete': 'delete', // 삭제
  'label.add': 'add', // 추가
  'label.conversion': 'Conversion', // 변환
  'label.selection': 'Selection', // 파일선택
  'label.search': 'search', // 검색
  'label.to-search': 'search', // 검색
  'label.all-registration': 'all registration', // 일괄등록
  'label.registration': 'registration', // 등록
  'label.allocation': 'allocation', // 할당
  'label.copy': 'copy', // 복사
  'label.download-excel': 'download excel', // 엑셀 다운로드
  'label.template': 'template', // 템플릿
  'label.duplicate-check': 'check', // 중복확인
  'label.select-equipment': 'select', // 장비선택
  'label.parent-dev-select': 'select', // 부모장비선택
  'label.select': 'select', // 선택
  'label.reset': 'reset', // 초기화
  'label.check': 'check', // 확인
  'label.update': 'update', // 수정
  'label.select-file': 'SelectFile', //  파일선택
  'label.apply': 'Apply', // 적용
  'label.download': 'Download', // 다운로드
  'label.cancel': 'Cancel', // 취소
  'label.equipment-type-mapping': 'equipment type mapping', // 장비유형 매핑
  'label.minW': 'Min Width',
  'label.minH': 'Min Height',
  'label.temp-save': '임시 저장',
  // 메세지
  'msg.save': 'It was saved.',
  'msg.update': 'It has been modified..',
  'msg.delete': 'It was deleted.',
  'msg.essential': 'Please enter the required value.',
  'msg.category-required-chart': 'Chart with category required.',
  'msg.delete-selected-template':
    'Are you sure you want to delete the selected template?',

  'msg.api-name-double-checked': 'API name needs to be double checked.',
  'msg.url-double-checked': 'URL redundancy check is required.',
  'msg.duplicate-header': 'Duplicate header found.',
  'msg.duplicate-body': 'Duplicate Body found.',
  'msg.api-save': 'API save completed.',
  'msg.api-update': 'API modification has been completed.',
  'msg.no-delete-target': 'There is no deletion target.',
  'msg.api-name-no': 'API name does not exist.',
  'msg.url-no': 'URL does not exist.',
  'msg.no-value-select': 'No value selected.',
  'msg.no-value-entered': 'No value entered.',

  'msg.duplicate-code': 'Duplicate Code',

  'msg.unregistered-equipment-property': 'Unregistered equipment property.',
  'msg.no-file-select': 'No file selected.',
  'msg.no-date-select': 'No data selected.',
  'msg.xlsx-upload-only': 'Only .xlsx files can be uploaded.',
  'msg.excel-upload-success': 'Excel upload succeeded.',
  'msg.excel-upload-fail': 'Excel upload failed.',
  'msg.select-required-equipment': 'Please select the appropriate equipment.',
  'msg.only-one-equipment': 'Only one equipment for copying can be selected.',
  'msg.assignment-customer-number':
    'Please enter the customer number to assign.',
  'msg.customer-number-no': 'This customer number does not exist.',
  'msg.customer-number': 'This customer number exists.',
  'msg.model-id-enter': 'Please enter a model ID',
  'msg.model-id-duplication': 'Duplicate model ID exists.',
  'msg.duplicate-check-completed': 'Duplicate check completed.',
  'msg.do-check-model-id': 'You need to check the duplicate model ID.',
  'msg.save-complete': 'Save is complete.',
  'msg.save-error': 'Error while saving.',
  'msg.select-row-delete': 'Please select Row to delete.',
  'msg.save-fail-try-again': 'Save failed. Please try again in a moment.',
  'msg.non-entry-equipment': 'There are non-inputable equipment attributes.',
  'msg.non-entry-equipment-set':
    'There are non-inputable equipment properties SET.',
  'msg.non-entry-ideal-set':
    'There is an abnormality SET that has not been entered.',

  'msg.pelect-program-name': 'Please select a program name.',
  'msg.select-template-name': 'Please select a template name.',
  'msg.select-template-type': 'Please select a template type.',
  'msg.select-template-image': 'Please select a template image.',

  'msg.date-correct-enter':
    'Please enter the correct start year/end year/ month.',
  'msg.date-cannot-great':
    'The month of the beginning cannot be greater than the year of the end.',
  'msg.inquiry-date-maximum7':
    'You can select a maximum of 7 days for the inquiry.',
  'msg.no-file-download': 'There are no files to download.',
  'msg.inquire-only-until-today': 'You can inquire only until today`s date.',

  'msg.no-reception-select': 'No recipients selected.',
  'msg.registration-complete': 'Registration completed.',
  'msg.registration-fail-try-again':
    'Registration failed. Please try again in a moment.',
  'msg.no-code-select': 'No code selected.',
  'msg.period-Invalid': 'Invalid lookup period.',
  'msg.check-use-number': 'Duplicate check required for license number.',
  'msg.check-installation-number':
    'Duplicate check required for installation number.',
  'msg.check-required-value': 'Please check the required value.',
  'msg.use-number-enter': 'Please enter the license number.',
  'msg.duplicate-check-complete': 'Duplicate check completed.',
  'msg.duplicate-use-number': 'Duplicate license number.',
  'msg.installation-number-check': 'Please check the installation number.',
  'msg.duplicate-installation-number': 'Duplicate installation number.',
  'msg.excel-upload-only': 'Only Excel files can be uploaded.',
  'msg.img-upload-only': 'Only image files can be uploaded.',
  'msg.equipment-modification-complete':
    'Modification of equipment has been completed.',
  'msg.error-try-again':
    'There was an error registering the equipment. Please try again in a few minutes.',
  'msg.equipment-registration-completion':
    'Equipment registration is complete.',
  'msg.no-selected-organization': 'No selected organization.',
  'msg.excel-download-completed': 'Excel download completed.',
  'msg.warn.min-size-greater-than-0': 'Minimum size must be greater than zero.',
  'msg.warn.never-been-modified': 'Not never been modified.',
  'msg.common.question.save': 'Do you want to save it?',
  'menu-management': 'Menu Management',
  'top-menu': 'Top Menu',
  'system-code': 'System Code',
  'menu-list': 'Menu List',
  'list-add': 'List Add',
  'label.menuList.button01': 'Add as a program list pop-up',
  'label.menuList.button02': 'Save as Excel Pop-up',
  'label.menuList.button03': 'Root Menu Add',
  'label.collective-registration': 'Collective Registration',
  'focused-note': 'Focused Note',

  'menu-log-management': 'Menu Log Management',
  'login-user-management': 'Login User Management',
  'login-ip': 'Login IP Division',

  affiliation: 'Affiliation',
  id: 'ID',
  'korean-title': 'Korean Title',
  'label.shortcut': 'shortcut',
  'menu-information': 'Menu Information',
  'menu-delete': 'menu delete',
  'menu-type': 'Menu Type',
  'expanding-if-folder': 'Expanding if folder',
  'save-program-id': 'Save program ID',
  'label.popup': 'popup',
  'change-icon': 'Change Icon',
  sequence: 'Sequence',
  'menu-enabled': 'Menu Enabled',
  'korean-display-name': 'Korean Display Name',
  'custom-practice': 'Custom practice',
  'more-information-1': 'More information-1',
  'more-information-2': 'More information-2',
  'more-information-3': 'More information-3',
  'multilingual-information': 'Multilingual Information',
  'save-multilinguals': 'Save Multilinguals',
  'label.add-selected-programs': 'add selected programs',
  'label.add-selected': 'add selected',
  system: 'System',
  'common-code': 'Common Code',
  'common-code-management': 'Common Code Management',
  'program-name': 'Program name',
  'program-management': 'Program Management',
  'label.adding-to-file': 'adding to file',
  'label.add-row': 'add row',
  'label.upload-manual': 'upload manual(multilingual)',
  'target-language': 'Target Language',
  'manage-permission-groups': 'Manage permission groups',
  'user-group-code': 'User group code',
  'api-group-auth-management': 'API Group Auth Managment',
  'expanded-auth': 'Expanded Auth',
  'enter-exauth': 'Enter the ID of the Expanded Auth',
  'delete-node': 'If any child exists, it cannot be deleted.',
  name: 'Name',
  'eng-name': 'Eng Name',
  position: 'Position',
  classification: 'Classification',
  'group-id': 'Group ID',
  'group-name': 'Group name',
  'permission-group': 'PermissionsAdd menu permissions by group',
  'permission-groups-code': 'Permission Groups Code',
  'permission-groups-name': 'Permission Groups Name',
  'permission-groups-menu': 'Permission Groups Menu',
  'auth-to-user': 'Users by permission',
  code: 'Code',
  group: 'Group',
  'etc-org-management': 'Etc Organization Management',
  'etc-user-management': 'Etc User Management',
  'etc-user-edit': 'Etc User Edit',
  'etc-user-add': 'Etc User Add',
  'enter-organization-name': 'Enter the organization name to add',
  'group-list': 'Group List',
  menu: 'Menu',
  'label.adding-to-group': 'adding to group',
  'menu-by-group': 'Menu by Group',
  'menu-per-user-permissions': 'Menu Per User Permissions',
  user: 'User',
  'equipment-status': 'Status Statistics Equipment',
  'equipment-type': 'Equipment Type',
  'device-rule': 'Device Model Rule Management',
  sortation: 'Sortation',
  'api-name': 'API Name',
  'terminal-type': 'Terminal type',
  tcp: 'Collection Rule settings',
  'verification-rule': 'Verification rule',
  'model-list': 'Model list(Conversion)',
  'conversion-list': 'Conversion by terminal(Conversion)',
  'server-name': 'Server Name',
  parsingul: 'Parsingul',
  'parsingul-professional': 'Parsingul(professional)',
  'mapping-rule': 'Mapping rule',
  'service-call': 'Service call',
  'service-name': 'Service Name',
  'equipment-model': 'Equipment Model',
  'name-equipment': 'Name Equipment',
  'number-use': 'Number Use',
  uuid: 'UUID',
  'installation-number': 'Installation Number',
  'item-number': 'Item Number',
  'equipment-image': 'Equipment Image',
  'registration-date': 'Registration Date',
  'management-organization': 'Management Organization',
  'installation-date': 'Istallation Date',
  'collection-cycle': 'Collection Cycle',
  'transfer-cycle': 'Transfer Cycle',
  'equipment-condition': 'Equipment Condition',

  // IOT API 관리
  add: 'Add',
  delete: 'Delete',
  'collection-Communication-success': 'Collection/Communication Success Rate',
  'client-company': 'Client Company',
  date: 'Date',
  // 장비 모델 관리
  api_management: 'API Management',
  'label.initialization': 'Initialization',
  url: 'URL',
  'server-division': 'serverDivision',
  'template-division': 'Template Division',
  explanation: 'Explanation',
  'device-model-management': 'Device Model Management',
  'usage-status': 'Usage Status',
  manufacturer: 'Manufacturer',
  'model-name': ' Model Name',
  'device-property': 'Device Property',
  'device-property-set': ' Device Property SET',
  'device-property-anomalies': 'Device Property Anomalies',
  property: 'Property',
  'model-id': 'Model ID',
  'customer-number': 'User Tel',
  target: 'Target',
  'parents-device-id': 'Parents Device ID',
  'disability-alarm-setting': 'Set Anomalies',
  'recipients-list': 'Recipients List',
  'shipment-type': 'Shipment Type',
  'shipment-content': 'Shipment Content',
  'organization-list': 'Organization List',
  'organization': 'Organization',
  'dashboard-setting': 'Dashboard Setting',
  'label.editing': 'editing',
  'add-widget': 'Add Widget',
  'label.close': 'close',
  'smm-sending-status': 'SMS Sending Status',
  period: 'Period',
  'shipping-period': 'shippingPeriod',
  kind: 'kind',
  'phone': 'Phone Number',
  'office-tel': 'Office Number',
  'sms-shipment-history': 'SMS Shipment History',
  'recipients-number': 'Receiver Tel',
  'message-type': 'Message Type',
  rating: 'Rating',
  title: 'Title',
  key: 'Key',
  label: 'Label',
  'y-axis-label': 'Y-axis Label',
  category: 'Category',
  'select-template': 'Select Template',
  'list-template': 'List of templates',
  'list-widget': 'List of widgets',
  'template-settings': 'Template Settings',
  'chart-component': 'Chart component',
  'control-history': 'Control History',
  'control-type': 'Control Type',
  'control-status': 'Control Status',
  'template-management': 'Template Management',
  'template-name': 'Template Name',
  'template-id': 'Template ID',
  'template-type': 'Template Type',
  'template-img': 'Template IMG',
  language: 'Language',
  'template-header': 'Template Header',
  'template-header-name': 'Template Name',
  index: 'index',
  'equipment-retrieveData': 'Equipment Retrieve Data',
  'response-time': 'Response time',
  'time-setting': 'Time setting',
  'equipment-attribute': 'Attribute of subscription equipment',

  // 2019년 5월 27일 추가 PKS
  'ApiGroupAuthManagement.title': 'API group Auth Management',
  'ApiGroupAuthManagement.subtitle1': 'group Managment',
  'ApiGroupAuthManagement.subtitle2': 'API list management',
  'ApiGroupAuthManagement.subtitle3': 'group List',

  // API 개인별 권한 관리를 위한 메세지
  'ApiPersonalAuthManagement.title': 'personal API Auth Mangement',
  'ApiPersonalAuthManagement.subtitle.personal': 'employee ID',
  'ApiPersonalAuthManagement.subtitle.api': 'API list Query',
  'ApiPersonalAuthManagement.subtitle.auth': 'personal API Auth',
  'ApiPersonalAuthManagement.label.person': 'add personal',
  'ApiPersonalAuthManagement.label.id': 'employee ID',
  'ApiPersonalAuthManagement.label.name': 'employee name',
  'ApiPersonalAuthManagement.label.system': 'system',
  'ApiPersonalAuthManagement.label.controller': 'controller',

  // API별 권한 부여 현황 관리
  'ApiAuthListMangement.title': 'API Auth Management',
  'ApiAuthListMangement.subtitle.api': 'API list',
  'ApiAuthListMangement.subtitle.person': 'API person list',
  'ApiAuthListMangement.subtitle.group': 'API group list',
  'ApiAuthListMangement.label.apiquery': 'API query',
  // API 목록 관리를 위한 메세지
  'ApiInfoManagement.title': 'API Information Management',
  'ApiInfoManagement.subtitle1': 'Query Condition',
  'ApiInfoManagement.lbl1': 'Controller',
  'ApiInfoManagement.lbl2': 'URI',

  'service-management': 'Service Management',
  'code-value': 'Code Value',
  'code-name': 'Code Name',
  'normal-icon': 'Normal Icon',
  'abnormal-icon': 'Abnormal Icon',
  'stop-icon': 'Stop Icon',

  // 장비제어
  'EquipmentControl.title': 'Equipment Control',
  'EquipmentControl.subtitle': 'Equipment Type',
  'EquipmentControl.label.control': 'control',
  'EquipmentControl.label.treatment': 'Treatment',
  'EquipmentControl.label.cancelReservation': 'Cancel Reservation',
  'EquipmentControl.label.timeSynchronisation': 'Time Synchronisation',

  select_none: 'none',

  // 현황 화면 컬럼 설정
  'dynamicColumn.title': 'Status Screen Column Settings',
  'dynamicColumn.label.title': 'Equipment Type',

  // 이상징후 설정
  'anomalies.title': 'Anomalies Attribute',
  'anomalies.subtitle.equipment': 'Equipment Standards',
  'anomalies.subtitle.alarm-method': 'Alarm Method',
  'anomalies.subtitle.alarm-title': 'Alarm Title',
  'anomalies.subtitle.alarm-content': 'Alarm Content',

  // 복합룰속성
  'complex-property': 'Complex Property',
  'general-property': 'General Property',
  'complex-equipment': 'Complexity by equipment',

  // 이차트
  'line-chart': 'Line Chart',
  'polar-bar-chart': 'Polar Bar Chart',
  'bar-chart': 'Bar Chart',
  'gauge-chart': 'Gauge Chart',
  'pie-chart': 'Pie Chart',
  'dynamic-chart': 'Dynamic Chart',

  // 이상징후 발송이력
  'disability-history': '이상징후 발송이력',

  // 위젯 관리
  'widget-management': '위젯 관리',

  'my-page': 'My Page'
}

export default messages
